import * as storage from 'client/javascript/storage';
import Overlay from 'client/javascript/overlay';
import setupWizard, { setStep1LocationTitle } from './index';
import { setupWizardTrackingEvents } from './tracking';
import {
  CLOSE_WIZARD_BTN_ID,
  OPEN_WIZARD_BTN_ID,
  CHECK_AVAILABILITY_ID,
  WIZARD_NODE_ID,
  getLocationDropdownSelectedId
} from './utils';

function setupWizardEvents(wizard, wizardOverlay) {
  const openWizardBtn = document.getElementById(OPEN_WIZARD_BTN_ID);
  const closeWizardBtn = document.getElementById(CLOSE_WIZARD_BTN_ID);

  closeWizardBtn.addEventListener('click', wizardOverlay.close);
  openWizardBtn.addEventListener('click', event => {
    event.preventDefault();

    setStep1LocationTitle();
    wizard.goToStep1();
    wizardOverlay.open();

    const locationDropdownId = getLocationDropdownSelectedId();
    storage.setLocationId(locationDropdownId);
  });
}

export function setupWizardOverlay() {
  const wizardNode = document.getElementById(WIZARD_NODE_ID);
  const showWizardStep2 = wizardNode.getAttribute('data-show-step-2') === 'true';

  const wizardOverlay = new Overlay('wizard-overlay', {
    excludeCloseButton: true,
    focusTrap: { initialFocus: `#${CHECK_AVAILABILITY_ID}` }
  });
  wizardNode.style.display = 'flex';
  wizardOverlay.addContent(wizardNode);

  const wizard = setupWizard(wizardNode, showWizardStep2);

  setupWizardEvents(wizard, wizardOverlay);
  setupWizardTrackingEvents(showWizardStep2);
}

export default setupWizardOverlay;
